import {IGridStatus}       from '../../ap-interface/interfaces/ap-grid-status.interface';
import {CropRotationYield} from '../../stores/farm/crop.rotation.store';
import IGuid = System.IGuid;
import IField = Data.FieldManagement.IField;
import ISoilSamplePlanning = Data.IpsPlanning.ISoilSamplePlanning;
import IFieldGeom = Data.FieldManagement.IFieldGeom;
import {SoilSampleScanning} from '../../stores/nutrients/soilsampleplanning.store';

/**
 * enumeration for all possible types of mass edit within this component
 */
export enum SoilSampleEdits {
  DeleteValues = 0,
  ShapeExport = 1,
  NextSample = 2,
  OrgApplication = 3,
  Description = 4,
  PdfExport = 5,
  XlsExport = 6,
  NextSampleDelete = 7,
  GridSize = 8,
  PlannedScan = 9
}

export enum SoilSamplePlannedScan {
  Yes = 1,
  No = 0
}

export interface IApFieldsWithSoilSamplePlanning {
  Id: IGuid;
  Field: IField;
  SoilSamplePlanning: ISoilSamplePlanning;
  SoilSampleScanning: SoilSampleScanning;
}

export enum SoilSampleScanningStatus {
  NotAvailable = 0,
  LessThan80 = 1,
  MoreThan80 = 2,
}

export interface ISoilSamplingGridData {
  Id: IGuid;
  FieldName: string;
  FieldNumber: number;
  FieldSumNumber: number;
  NrSNr: string;
  LandUse: IGridStatus;
  ScanningData: SoilSampleScanning;
  ScanningDataValue: SoilSampleScanningStatus;
  ScanningDataClass: string;
  ScanningDataTooltip: string;
  SamplingStatus: IGridStatus;
  Geom: IFieldGeom | undefined;
  Area: number | undefined;
  LastSamplingDate: Date | undefined;
  NextSamplingDate: Date | undefined;
  OrganicApplication: string;
  PlannedScan: boolean;
  GridSize: number | undefined;
  SampleAmount: number | undefined;
  Crop: { [key: number]: CropRotationYield };
  Note: string;
  SourceItem: IApFieldsWithSoilSamplePlanning;
}

export enum SoilSamplePlanningOverviewActions {
  YES = 1,
  NO = 0
}
